import { Dialog } from "@mui/material";
import { Button } from "../../common/Button/Button";

import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AGGTable } from "./AGGTable";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ButtonHolder, ButtonPrimary, DialogCustom } from "./style";

export const CSVPreview = ({
  parsedData,
  close,
  removeFile,
  removeFileById,
}: {
  parsedData: any;
  close: () => void;
  removeFile: () => void;
  removeFileById: (id: string) => void;
}) => {
  var settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    cssEase: "cubic-bezier(0.7, 0, 0.3, 1)",
    touchThreshold: 100,
  };

  return (
    <DialogCustom
      open={parsedData?.length > 0}
      onClose={() => close()}
      fullWidth
      sx={{
        ".MuiPaper-elevation": {
          width: "100%",
          maxWidth: "1400px",
          transform: "translateX(0px)",
          overflowX: "hidden",
        },
      }}
    >
      {parsedData?.length > 1 ? (
        <Slider {...settings}>
          {parsedData?.map((data: any) => (
            <div key={data.id}>
              <AGGTable key={data.id} parsedData={data.rows} />
              <Button
                variant="outlined"
                className="red"
                onClick={() => removeFileById(data.id)}
              >
                Remove
              </Button>
            </div>
          ))}
        </Slider>
      ) : (
        parsedData?.length === 1 && <AGGTable parsedData={parsedData[0].rows} />
      )}
      <ButtonHolder>
        <Button variant="outlined" className="red" onClick={() => removeFile()}>
          {parsedData?.length > 1 ? "Remove All Files" : "Remove File"}
        </Button>
        <ButtonPrimary onClick={() => close()}>
          {parsedData?.length > 1 ? "Accept All" : "Accept"}
        </ButtonPrimary>
      </ButtonHolder>
    </DialogCustom>
  );
};
